import PANCARD from "../../assets/images/pancardbg.avif";
import { FormikProps } from "formik";
import { VscVerifiedFilled } from "react-icons/vsc";
import { IReviewBookingDetails } from "./reviewbookingModel";

const PanInfoCard = ({
  formik,
  fieldRefs,
  maskedName,
  panStatus,
  setPanStatus,
  lastVerifiedPan,
}: {
  formik: FormikProps<IReviewBookingDetails>;
  fieldRefs: any;
  setPanStatus: (status: "idle" | "valid" | "invalid" | "loading") => void;
  maskedName: string;
  lastVerifiedPan: string | null;
  panStatus: string;
}) => {
  return (
    <div className="pan-form-card">
      <form className="pan-form">
        <h4 className="mb-1">PAN Details</h4>
        <span>As per RBI, PAN Details are mandatory for this booking</span>

        <div
          className="field mt-3 pancard-field"
          onClick={() => {
            fieldRefs.current["billing_pan_card_no"]?.focus?.();
          }}
        >
          <input
            type="text"
            name="billing_pan_card_no"
            // ref={inputRef}
            value={formik.values.billing_pan_card_no?.toUpperCase()}
            onChange={(e) => {
              const val = e.target.value.toUpperCase().slice(0, 10);
              formik.setFieldValue("billing_pan_card_no", val);

              if (val !== lastVerifiedPan) {
                setPanStatus("idle");
              }
            }}
            placeholder="Enter PAN No here"
            onBlur={formik.handleBlur}
            className={
              formik.touched.billing_pan_card_no &&
              formik.errors.billing_pan_card_no
                ? "error-border"
                : ""
            }
            // ref={(el) => {
            //   if (el) {
            //     fieldRefs.current["billing_pan_card_no"] = el;
            //   }
            // }}
          />

          {panStatus === "loading" && (
            <div className="status">Verifying...</div>
          )}

          {panStatus !== "loading" && (
            <>
              {formik.touched.billing_pan_card_no &&
                formik.errors.billing_pan_card_no &&
                typeof formik.errors.billing_pan_card_no === "string" && (
                  <div className="status error-label">
                    {formik.errors.billing_pan_card_no}
                  </div>
                )}

              {panStatus === "invalid" &&
                !formik.errors.billing_pan_card_no && (
                  <div className="status error-label">Invalid PAN!</div>
                )}
            </>
          )}

          {panStatus === "valid" && !formik.errors.billing_pan_card_no && (
            <div className="status success">
              {maskedName}{" "}
              <VscVerifiedFilled style={{ fontSize: 16, color: "#00a34d" }} />
            </div>
          )}
        </div>
      </form>
      <div className="image-section">
        <img src={PANCARD} alt="" />
      </div>
    </div>
  );
};

export default PanInfoCard;
